import {useState} from 'react';
import {AccessCodeFormContent} from '~/components/events/AccessCodeFormContent';

import type {Event} from '~/types/models';

export function AccessCodeForm({event}: {event: Event}) {
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState<{
    general?: string;
    access_code?: string;
  }>({
    general: undefined,
    access_code: undefined,
  });

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();

    const target = e.target as typeof e.target & {
      access_code: {value?: string};
    };
    const accessCode = target.access_code.value;

    setSubmitting(true);

    try {
      const accessResponse = await fetch('/api/events/authorization', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          eventHandle: event.handle,
          accessCode,
        }),
      });

      if (accessResponse.status !== 200) {
        const {errors} = await accessResponse.json();
        setErrors(errors);
        return;
      }

      location.reload();
    } catch (error: any) {
      setErrors({
        general: 'An error occurred',
      });
    }

    setSubmitting(false);
  };

  return (
    <div className="mx-auto w-full max-w-md space-y-8">
      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 gap-y-6"
        autoComplete="off"
      >
        <AccessCodeFormContent submitting={false} error={errors.access_code} />
      </form>
    </div>
  );
}
